import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    spinnerAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the spinner */
            spinnerAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItem.spinnerAriaLabel?c=25d15suvch2eq", defaultMessage: "Spinner" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
